import React, { useRef } from 'react';

import { iconsSourcesCustom } from '../../helpers/icons';
import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import {
  clearTextFromTags,
  hideNumber,
  maskNumber,
} from '../../helpers/titreHelper';

const Message = ({
  className,
  message,
  titrTag,
  setDelay,
  messagesWrapper,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
  user,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const isCurrent = currentMessageRef?.message?.id === message?.id;

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper,
    isCurrent
  );

  const errorHandler = (e) => {
    e.target.src = iconsSourcesCustom['sms'];
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      {message && (
        <>
          <div className={styles.avatar}>
            <img
              src={
                iconsSourcesCustom[message?.channel] ||
                iconsSourcesCustom['sms']
              }
              alt={message?.author}
              onError={errorHandler}
            />
          </div>

          <div className={styles.contentWrapper}>
            <div
              className={cn(styles.name)}
              style={{ fontSize: `${authorFontSize}rem` }}
            >
              {maskNumber(message?.senderNumber, user, message.channel)}
            </div>

            <div className={styles.content}>
              <div
                className={styles.textWrapper}
                ref={contentContainerRef}
                style={{
                  maxHeight: `${14 * 1.2 * msgFontSize}rem`,
                }}
              >
                {message?.content && (
                  <div
                    className={styles.text}
                    ref={contentRef}
                    style={{
                      fontSize: `${msgFontSize}rem`,
                    }}
                  >
                    {clearTextFromTags(message.content)}
                  </div>
                )}
              </div>

              {/* {message?.attachments &&
                message?.attachments[0] &&
                message.attachments[0].type === 'image' && (
                  <div className={styles.contentImg}>
                    <img
                      src={message?.attachments[0].url}
                      alt={message?.author || hideNumber(message?.senderNumber)}
                    />
                  </div>
                )} */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
